export default __webpack_public_path__ + "static/media/clock.1be9688d.jpeg";